/* global axios */
import ApiClient from './ApiClient';

class CreditsAPI extends ApiClient {
  constructor() {
    super('credits', { accountScoped: true });
  }

  balance() {
    return axios.get(`${this.url}/balance`);
  }

  transactions({ limit = 50, offset = 0 } = {}) {
    return axios.get(`${this.url}/transactions`, { params: { limit, offset } });
  }

  recharge(amount) {
    return axios.post(`${this.url}/recharge`, { amount });
  }
}

export default new CreditsAPI();
